<div class="datagridsdiebar">
    <div class="datagridsidebar__header bg">
        <h2>View</h2>
        <!-- <div [class]="'editviewname ' + (nameEdit ? ' edit-allowed' : '')">
            @if (cadvFilters.currentView.id) {
                <h2 #content [contentEditable]="nameEdit"> {{ cadvFilters.currentView.name }} </h2>
                @if (nameEdit) {
                <span (click)="onNameSave($event)" style="cursor: pointer;"><i class="fa fa-save"></i></span>
                } @else {
                <span (click)="nameEdit = true" style="cursor: pointer;"><i class="fa fa-pencil"></i></span>
            }

            }
            <h2>Filters ({{ cadvFilters.getFiltersLength() }})</h2>
        </div> -->
        <div class="sidebar__action">
            <span class="advanced-filter">Applied filters ({{ cadvFilters.getFiltersLength() }})</span>
            <a class="close" (click)="onClose($event)"><i class="fa-regular fa-times"></i></a>
        </div>
    </div>
    <div class="view-content">
        <div class="datagrid-form">
            <div class="view-name">
                <label for="name">Name <span class="required"><i class="fa fa-asterisk"></i></span></label>
                <input                
                  (blur)="onNameSave($event, null)"
                  [ngStyle]="{ 'outline': 'none', 'border': 'none', 'font-weight': 'bold' } "
                  [(ngModel)]="cadvFilters.currentView.name"
                  (ngModelChange)="onNameChange($event)"
                  class="form-control"
                  type="text" />
            </div>
        </div>

        <div class="flex-row--inner">
    
            @if ((cadvFilters.filters | cxShowableGroupPipe).length === 0) {
            <div class="empty-filter-container">
                <button (click)="addGroupAndField($event)" class="btn-bg">Add Filter</button>
            </div>
            }
    
            @for (group of cadvFilters.filters; track groupIndex; let groupIndex = $index) {
            @if (!group.deleted) {
            <div class="flex-col-sm-12">
                <div class="datagrid-filter-group">

                    <div style="margin-left: 18px;" class="group-header">
                        <span>{{ 'Group ' + getGroupIndex(group.gid) }}</span>
                        <i (click)="removeGroup($event, groupIndex)" class="fa-thin fa-trash"></i>
                    </div>

                    <!-- <button (click)="removeGroup($event, groupIndex)" class="btn-bg delete-group"><i
                            class="fa fa-trash"></i></button> -->
                    @for (filter of group.filters; track filterIndex; let filterIndex = $index) {
                    @if (!filter.deleted) {
                        <div class="field-with-operator">
                            <div class="and-sign" style="min-width: 8px;">&</div>
                            <div class="datagrid-filter-group-field" (click)="editFilter($event, filter, groupIndex, filterIndex)">
                                <span>{{ filter.label }} {{ filter.operatorLabel }}</span>
                                <span class="values">
                                    {{ printSelectedValues(filter) }}
                                </span>
                                <button (click)="removeField($event, filterIndex, groupIndex, filter)"
                                    class="btn-bg delete-field"><i class="fa fa-times"></i></button>
                            </div>
                        </div>
                    }
                    }
                    @if ((group.filters | cxShowableField).length === 0) {
                    <button style="margin-left: 18px; margin-top: 4px;" (click)="addField($event, groupIndex)" class="btn-bg">Add Filter</button>
                    } @else {
                    <button style="margin-left: 18px; margin-top: 4px;" (click)="addFilter($event, groupIndex)" class="btn-bg">Add Filter</button>
                    }
                </div>
                <div class="or-area">
                    <div class="or-pipe or-pipe-top"></div>
                    <button (click)="addGroup($event)" class="btn-bg btn--dark">OR</button>
                    <div  class="or-pipe or-pipe-bottom"></div>
                </div>
            </div>
            }
            }
        </div>
    
    
        <div class="datagridsidebar__footer">
            @if (cadvFilters.hasRemovedFilters()) {
            <div class="sidebar__action">
                <a (click)="saveFilters($event)" class="btn-bg save">Save</a>
                <a (click)="revert($event)" class="btn-bg revert">Revert</a>
            </div>
            } @else if (!cadvFilters.currentView.id) {
            <div class="sidebar__action">
                <a (click)="onCreateView($event)" class="btn-bg btn-sm">Create view</a>
            </div>
            }
        </div>
    </div>
</div>